mutation CompanyCardCompanyDelete( $input:CompanyCardCompanyDeleteInput!) {
  companyCardCompanyDelete(input: $input) {
    deletedEntities {
      rowTimestamp
      id
    }
  }
}
